import { isAddress } from 'viem'
import { z } from 'zod'

import { checkInvalidAmount } from '../utils'

export const evmTokenTransferSchema = z
    .object({
        balance: z.bigint().default(0n),
        recipient: z
            .string()
            .min(1, 'Recipient address is required')
            .refine((value) => isAddress(value), {
                message: 'Invalid address',
            }),
        amount: z.string().min(1, 'Amount is required'),
        decimals: z.number().default(18),
    })
    .superRefine((data, ctx) => {
        if (isNaN(Number(data.amount))) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'Please enter a valid number.',
                path: ['amount'],
            })
        } else {
            const validationResult = checkInvalidAmount({
                value: data.amount,
                balance: data.balance,
                decimals: data.decimals,
            })
            if (validationResult) {
                ctx.addIssue({
                    code: z.ZodIssueCode.custom,
                    message: validationResult.message,
                    path: ['amount'],
                })
            }
        }
    })

export type EvmTokenTransfer = z.infer<typeof evmTokenTransferSchema>
